import React from 'react'
import SuccessStoriesOverview from '../../../react4xp/components/SuccessStoriesOverview'

function SuccessStoriesOverviewPart({ title, highlightedSuccessStory, endpoint, firstPageStories, hasSecondPage, pageNumber, strings }) {
    return (
        <SuccessStoriesOverview
            title={title}
            endpoint={endpoint}
            highlightedSuccessStory={highlightedSuccessStory}
            firstPageStories={firstPageStories}
            hasSecondPage={hasSecondPage}
            pageNumber={pageNumber}
            strings={strings}
        />
    )
}

export default (props) => <SuccessStoriesOverviewPart {...props} />
